import type { RouteObject } from "react-router-dom";

import Account from "../deprecated/routes/account/index";
import Billing from "../deprecated/routes/billing/index";
import CreateAccount, {
  clientAction as createAccountClientAction,
} from "../deprecated/routes/create-account/index";
import Dashboard, {
  clientLoader as dashboardLoader,
} from "../deprecated/routes/dashboard/index";
import DashboardNotFound from "../deprecated/routes/dashboard-not-found/index";
import Home, {
  clientLoader as homeLoader,
} from "../deprecated/routes/home/index";
import AuthenticatedLayout from "../deprecated/routes/layouts/authenticated/index";
import DashboardLayout, {
  clientLoader as dashboardLayoutLoader,
} from "../deprecated/routes/layouts/dashboard/index";
import PatientLayout from "../deprecated/routes/layouts/patient/index";
import LoginCallback from "../deprecated/routes/login/callback/index";
import Login from "../deprecated/routes/login/index";
import Logout, {
  clientAction as logoutAction,
} from "../deprecated/routes/logout/index";
import PatientBriefingRoute from "../deprecated/routes/patient-briefing/index";
import PatientEncounterRoute from "../deprecated/routes/patient-encounter/index";
import PatientEncountersRoute from "../deprecated/routes/patient-encounters/index";
import PatientIndex from "../deprecated/routes/patient-index/index";
import PatientIndexRedirect from "../deprecated/routes/patient-index/redirect";
import PatientTodayRoute from "../deprecated/routes/patient-today/index";
import Patients from "../deprecated/routes/patients/index";
import SignupCompletion from "../deprecated/routes/signup-completion/index";

/**
 * V1 (deprecated) route tree, restored for the Elation iframe embed so chart
 * patient-open still lands on briefing/today/history. Standalone web and the
 * chrome extension keep the promoted v2 routes.
 */
export function createV1Routes(): RouteObject[] {
  return [
    {
      index: true,
      element: <Home />,
      loader: homeLoader,
    },
    {
      path: "login",
      element: <Login />,
    },
    {
      path: "login/callback",
      element: <LoginCallback />,
    },
    {
      path: "create-account",
      element: <CreateAccount />,
      action: createAccountClientAction,
    },
    {
      path: "signup-completion",
      element: <SignupCompletion />,
    },
    {
      id: "dashboard",
      path: "dashboard",
      element: <AuthenticatedLayout />,
      children: [
        {
          path: "",
          element: <DashboardLayout />,
          loader: dashboardLayoutLoader,
          children: [
            {
              index: true,
              element: <Dashboard />,
              loader: dashboardLoader,
            },
            {
              path: "account",
              element: <Account />,
            },
            {
              path: "not-found",
              element: <DashboardNotFound />,
            },
            {
              path: "patients",
              element: <Patients />,
            },
            {
              path: "patients/:patientId",
              element: <PatientLayout />,
              children: [
                {
                  element: <PatientIndex />,
                  children: [
                    {
                      index: true,
                      element: <PatientIndexRedirect />,
                    },
                    {
                      path: "briefing",
                      element: <PatientBriefingRoute />,
                    },
                    {
                      path: "today",
                      element: <PatientTodayRoute />,
                    },
                    {
                      path: "encounters",
                      element: <PatientEncountersRoute />,
                    },
                    {
                      path: "encounter/:encounterId",
                      element: <PatientEncounterRoute />,
                    },
                  ],
                },
              ],
            },
            {
              path: "billing",
              element: <Billing />,
            },
            {
              path: "logout",
              element: <Logout />,
              action: logoutAction,
            },
          ],
        },
      ],
    },
  ];
}
